var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point_purchase"},[_vm._m(0),_c('point-purchase-list',{attrs:{"info":_vm.info}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text_center"},[_c('h2',{staticClass:"header_underline"},[_vm._v("鑑定ポイント購入")])])
}]

export { render, staticRenderFns }